var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "none",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.9983C21 20.2635 20.8946 20.5179 20.7071 20.7054C20.5196 20.893 20.2652 20.9983 20 20.9983H4C3.73478 20.9983 3.48043 20.893 3.29289 20.7054C3.10536 20.5179 3 20.2635 3 19.9983V9.48832C2.99989 9.33593 3.03462 9.18554 3.10152 9.04862C3.16841 8.9117 3.26572 8.79188 3.386 8.69832L11.386 2.47632C11.5615 2.33976 11.7776 2.26562 12 2.26562C12.2224 2.26562 12.4385 2.33976 12.614 2.47632L20.614 8.69832C20.7343 8.79188 20.8316 8.9117 20.8985 9.04862C20.9654 9.18554 21.0001 9.33593 21 9.48832V19.9983ZM19 18.9983V9.97632L12 4.53232L5 9.97632V18.9983H19Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd150745513d70f21654aa8b902b6be3.svg";
export { ForwardRef as ReactComponent };